module.exports = __webpack_public_path__ + "images/pages/for_business/sp/sec10_af7d45be777d94ba1af7939bf6742a9a.jpg";